import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungBielefeld() {
  return (
    <CityPageTemplate
      city="Bielefeld"
      slug="bielefeld"
      intro="Bielefeld existiert – und Deine Altersvorsorge sollte es auch. Wir helfen Dir dabei."
      description="Unabhängige Finanzberatung für Bielefeld – 100% digital, kostenlose Erstberatung. Altersvorsorge, ETF, Steueroptimierung & staatliche Förderungen."
    />
  );
}
